<template>
  <div class="separate-medicine">
    <b-overlay :show="loadingVerify" opacity="0.99">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
          <Medicine
            :group_prescription_medicine="group_prescription_medicine"
          />
        </div>
        <div
          v-if="!checked && !other_stock && stock_group_resident.length > 0"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
        >
          <label>ESTOQUE QUE VAI DAR BAIXA <strong>(RESIDENTE)</strong></label>
          <select v-model="stocked_item_id" class="form-control">
            <option value="">SELECIONE...</option>
            <option
              v-for="(item, key) in stock_group_resident"
              :key="key"
              :value="item.stocked_item_id"
            >
              {{ item.stock_owner }}
            </option>
          </select>
        </div>
        <div
          v-if="!checked && !other_stock && stock_group_resident.length == 0"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
        >
          <p class="errorMessages mb-2">
            Residente não possui o medicamento no estoque!
          </p>
        </div>
        <div
          v-if="!checked && other_stock && stock_group.length > 0"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
        >
          <label>ESTOQUE QUE VAI DAR BAIXA <strong>(OUTROS)</strong></label>
          <select v-model="stocked_item_id" class="form-control">
            <option value>SELECIONE...</option>
            <option
              v-for="(item, key) in stock_group"
              :key="key"
              :value="item.stocked_item_id"
            >
              {{ item.stock_owner }}
            </option>
          </select>
        </div>
        <div
          v-if="!checked && other_stock && stock_group.length == 0"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
        >
          <WarningMessage
            message="Nenhum outro estoque encontrado com o medicamento!"
          />
        </div>
        <div
          v-if="!checked"
          class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
        >
          <v-btn
            :disabled="!other_stock"
            @click="handleToStockResident"
            class="btn-annotation btn-block pb-4 pt-4"
            >ESTOQUE DO RESIDENTE</v-btn
          >
        </div>
        <div
          v-if="!checked"
          class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
        >
          <v-btn
            :disabled="other_stock"
            @click="handleToOtherStock"
            class="btn-annotation btn-block pb-4 pt-4"
            >SELECIONAR ESTOQUE <br />
            DE OUTRO RESIDENTE</v-btn
          >
        </div>
        <div
          v-if="!checked && enough_stocks.length > 0"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0 pt-1"
        >
          <div class="col-xl-12 v-clean pt-0 pl-0 pr-0 pb-2">
            <h6 class="upper-text text-fourteen worksansr p-2 mb-0">
              <i
                class="fas fa-exclamation-circle color-warning text-twenty mr-1"
              ></i>
              Estoque(s) do residente que possui o medicamento:
            </h6>
            <h6
              class="upper-text pl-2 mb-0"
              v-for="(item, key) in enough_stocks"
              :key="key"
            >
              <strong class="">{{ item.stock_owner }}.</strong>
            </h6>
          </div>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="notdiv-realized">
            <b-form-checkbox
              @input="handleChabgeChecked"
              id="checked"
              v-model="checked"
              name="checked"
              class="mb-1"
            >
              MARCAR COMO NÃO REALIZADO?
            </b-form-checkbox>
            <h6 class="color-deleted mb-0 worksansr" v-if="checked">
              MOTIVO DA NÃO REALIZAÇÃO:
            </h6>
            <ChromeSpeechToTextTextarea
              rows="4"
              max-rows="10"
              v-model="note"
              v-if="checked"
            />
          </div>
        </div>
        <div
          v-if="false"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          JUSTIFICATIVA DA CHECAGEM COM ATRASO
          <ChromeSpeechToTextTextarea
            rows="4"
            max-rows="10"
            v-model="justification"
          />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
          <p
            v-for="(error, index) in errors"
            :key="index"
            class="errorMessages mb-2"
          >
            {{ error.message || error }}
          </p>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
          <v-btn
            :disabled="loading"
            @click="handleToSeparate"
            :class="[!checked && 'btn-save', checked && 'btn-notcertified']"
          >
            <i class="fas fa-check mr-2 text-twenty"></i>
            <span v-if="!checked">
              {{ loading ? "CARREGANDO" : "AVANÇAR" }}
            </span>
            <span v-if="checked">
              {{
                loading
                  ? "CARREGANDO"
                  : "FINALIZAR MANUAL COM ASSINATURA ELETRÔNICA"
              }}
            </span>
          </v-btn>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import WarningMessage from "../../../Components/WarningMessage";

import ChromeSpeechToTextTextarea from "../../../Components/ChromeSpeechToTextTextarea";

import routes from "../../../../routes";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import Medicine from "../Medicine";

import { userData } from "../../../../lib/functions";

import { formatDateOnlyNumbers } from "../../../../lib/format";

export default {
  name: "Separate",
  components: {
    Medicine,
    WarningMessage,
    ChromeSpeechToTextTextarea,
  },
  props: {
    group_prescription_medicine: Object,
    date: String,
  },
  data() {
    return {
      resident_id: "",
      rest_home_id: "",
      stocked_item_id: "",
      stock_id: "",
      enough_stocks: [],
      stocksByMedicine: [],
      stocksResidentByMedicine: [],
      note: "",
      justification: "",
      show_justification: false,
      checked: false,
      other_stock: false,
      loading: false,
      loadingVerify: false,
      hasInStock: false,
      errors: [],

      stock_group: [],
      stock_group_resident: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDateOnlyNumbers,
    handleChabgeChecked() {
      this.stock_id = "";
      this.other_stock = false;
    },
    handleToSeparate() {
      let { checked, note } = this;

      if (checked) {
        if (!note || !String(note).trim()) {
          this.errors = [{ id: 1, message: "Informe a observação" }];
          return;
        }
      }

      this.separate();
    },
    handleToStockResident() {
      this.stock_id = "";
      this.errors = [];
      this.other_stock = false;
    },
    handleToOtherStock() {
      this.stock_id = "";
      this.errors = [];
      this.other_stock = true;
      this.enough_stocks = [];
    },
    async retrieve() {
      this.errors = [];
      this.show_justification = false;

      let { rest_home_id } = userData();

      this.rest_home_id = rest_home_id;

      const { id } = routes.history.current.params;

      this.resident_id = id;

      let { date } = this;

      if (
        parseInt(formatDateOnlyNumbers(date)) <
        parseInt(formatDateOnlyNumbers(new Date()))
      ) {
        this.show_justification = true;
      }

      await this.getStocksByMedicine();
      await this.getOtherStocksByMedicine();
    },
    async getStocksByMedicine() {
      try {
        this.loadingVerify = true;

        const {
          group_prescription_medicine: {
            prescription_medicine: { medicine_id },
            prescription_medicine_time: { quantity },
          },
          resident_id,
        } = this;

        let params = { medicine_id, quantity };

        const response = await api.get(
          "/rest-home/resident/medicine-check/stock-by-medicine",
          { params }
        );

        const { error, errors, stock_group } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          let stock_group_resident = [];

          for (let stock of stock_group) {
            if (stock.resident_id == resident_id) {
              stock_group_resident.push(stock);
            }
          }

          if (stock_group_resident.length > 0) {
            this.stocked_item_id = stock_group_resident[0].stocked_item_id;
          }

          this.stock_group_resident = stock_group_resident;
          this.errors = [];
        }

        this.loadingVerify = false;
      } catch (error) {
        this.loadingVerify = false;
        console.log(error);
      }
    },
    async getOtherStocksByMedicine() {
      try {
        this.loadingVerify = true;

        const {
          group_prescription_medicine: {
            prescription_medicine: { medicine_id },
            prescription_medicine_time: { quantity },
          },
          resident_id,
        } = this;

        let params = {
          medicine_id,
          quantity,
          resident_id,
          compare_resident: "DIFERENTE",
        };

        const response = await api.get(
          "/rest-home/resident/medicine-check/stock-by-medicine",
          { params }
        );

        const { error, errors, stock_group } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          let stock_group_others = [];

          for (let stock of stock_group) {
            if (stock.resident_id != resident_id) {
              stock_group_others.push(stock);
            }
          }

          this.stock_group = stock_group_others;
          this.errors = [];
        }

        this.loadingVerify = false;
      } catch (error) {
        this.loadingVerify = false;
        console.log(error);
      }
    },
    async separate() {
      try {
        this.loading = true;

        let {
          stocked_item_id,
          stock_id,
          checked,
          note,
          group_prescription_medicine: {
            prescription_medicine_time: { id },
          },
          date,
          justification,
        } = this;

        let params = {
          stocked_item_id,
          stock_id,
          checked,
          note,
          id,
          date,
          justification,
        };

        const response = await api.post("/rest-home/check/separate", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
          this.$emit("checked");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
